export enum ReportStatusEnum {
  PROCESSED = 'Processed',
  PROCESSING = 'Processing',
}
